import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { CarouselItemStyle, TutoStepContent } from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant2',
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
  imports: [SafePipe, VariableReplacementPipe],
})
export class Variant2Component extends BaseComponent {
  itemStyle = input.required<Omit<CarouselItemStyle, 'title'>>();
  stepContent =
    input.required<Omit<TutoStepContent, 'indicatorImage' | 'title'>>();
}
